import { ACTION_TYPES } from "../constants/actionTypes";

const defaultState = {
  loggedIn: false,
  token: null,
  refreshToken: null,
  is_new_user: true,
  phone: null,
  isLoading: false,
};

const auth = (state = defaultState, action) => {
  switch (action.type) {
    case ACTION_TYPES.APP.LOGOUT: {
      return { ...defaultState };
    }

    case ACTION_TYPES.AUTH.LOADING: {
      return { ...state, isLoading: action.data };
    }
    default:
      return state;
  }
};

export default auth;
